import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.scss';
import { ThemeProvider } from 'styled-components';
import { SharedStateProvider } from './context/SharedContext/SharedContext';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AccountPageLayout, PageLayout, AccountInformationLayout } from './layouts';
import { createTheme } from '@mui/material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { CoreRoutes } from './app-constants/Routes/Routes';
import {
	ConfirmEmailPage,
	ChangeEmailPage,
	Customers,
	Home,
	LoginPage,
	Organization,
	Products,
	RequestPasswordReset,
	ResetPassword,
	Sales,
	Partners,
	Administration,
	Reporting,
	LogOutPage,
	AccountInformationPage,
} from './pages';

const theme = createTheme({});
const queryClient = new QueryClient();
const container = document.getElementById('root');
const root = createRoot(container);
root.render(
	<React.StrictMode>
		<ThemeProvider theme={theme}>
			<SharedStateProvider>
				<LocalizationProvider dateAdapter={AdapterDayjs}>
					<QueryClientProvider client={queryClient}>
						<BrowserRouter>
							<Routes>
								<Route element={<AccountPageLayout />}>
									<Route path={CoreRoutes.confirmEmail} element={<ConfirmEmailPage />} />
									<Route path={CoreRoutes.login} element={<LoginPage />} />
									<Route path={CoreRoutes.resetPassword} element={<ResetPassword />} />
									<Route path={CoreRoutes.requestPasswordReset} element={<RequestPasswordReset />} />
									<Route path={CoreRoutes.changeEmail} element={<ChangeEmailPage />} />
								</Route>
								<Route element={<PageLayout />}>
									<Route path={CoreRoutes.home} element={<Home />} />
									<Route path={CoreRoutes.sales} element={<Sales />} />
									<Route path={CoreRoutes.products} element={<Products />} />
									<Route path={CoreRoutes.administration} element={<Administration />} />
									<Route path={CoreRoutes.organization} element={<Organization />} />
									<Route path={CoreRoutes.partners} element={<Partners />} />
									<Route path={CoreRoutes.customers} element={<Customers />} />
									<Route path={CoreRoutes.reporting} element={<Reporting />} />
									<Route path={CoreRoutes.logout} element={<LogOutPage />} />
									<Route path={CoreRoutes.wildcard} element={<Navigate to={CoreRoutes.home} replace />} />
								</Route>
								<Route element={<AccountInformationLayout />}>
									<Route path={CoreRoutes.accountInformation} element={<AccountInformationPage />} />
								</Route>
							</Routes>
						</BrowserRouter>
					</QueryClientProvider>
				</LocalizationProvider>
			</SharedStateProvider>
		</ThemeProvider>
	</React.StrictMode>
);
